import client from './client.js';

/**
 * Avocash virtual chat identity API — maps to AvocashChatAdminController
 * (@RequestMapping("/api/admin/messaging/avocash")).
 *
 * Request/response shapes mirror AvocashChatDTOs:
 *  - ProvisionRequest / ProvisioningStatus
 *  - ChannelRequest / ChannelView
 *  - SystemUserRequest / SystemUserView
 *  - ConnectGroupRequest
 *  - ResolveSenderRequest / SystemUserView
 */

function url(path) {
  return '/admin/messaging/avocash' + path;
}

export function provisionAvocash(request = {}) {
  return client.post(url('/provision'), request).then((r) => r.data);
}

export function getAvocashStatus() {
  return client.get(url('/status')).then((r) => r.data);
}

export function createChannel(request) {
  return client.post(url('/channels'), request).then((r) => r.data);
}

export function createSystemUser(request) {
  return client.post(url('/system-users'), request).then((r) => r.data);
}

export function connectToGroup(request) {
  return client.post(url('/connect/group'), request).then((r) => r.data);
}

export function resolveSender(request) {
  return client.post(url('/resolve-sender'), request).then((r) => r.data);
}

export default {
  provisionAvocash,
  getAvocashStatus,
  createChannel,
  createSystemUser,
  connectToGroup,
  resolveSender,
};
